import { Button, Group, Loader } from "@mantine/core";
import {
  IconArrowLeft,
  IconDownload,
  IconFileText,
  IconPrinter,
} from "@tabler/icons-react";
import { navigateTo } from "common/navigation";
import React, { useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { PrintContext } from "./PrintContext";

const MainPrintPage: React.FC = () => {
  const [params] = useSearchParams();
  const [exporting, setExporting] = useState(false);
  const id = params.get("id");
  const type = params.get("t");
  const rptType = params.get("rpt");
  const ReportType = rptType ? Number(rptType ?? 0) : 0;
  const backToOrderEntry = (params.get("e") ?? "0") === "1";

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const filename = pathname.split("/").filter(Boolean).pop();
  const isGPMRoute =
    pathname.includes("/print/gross-profit-margins") ||
    pathname.includes("/print/sales-profit-margins") ||
    pathname.includes("/print/sales-analysis") ||
    pathname.includes("/print/sales-person-by-month");
  const isPriceListRoute = pathname.includes("/print/price-list");
  const isSupplierOrderRoute = pathname.includes("/print/supplier-order");
  /*pathname.includes("/print/supplier-order?") ||
    pathname.includes("/print/supplier-order/") ||
    pathname.includes("/print/supplier-order/?");*/
  const isPaymentRoute = pathname.includes("/print/payment");
  const [csvRequestId, setCsvRequestId] = useState(0);
  const triggerCsvDownload = () => {
    setCsvRequestId((prev) => prev + 1);
  };
  const contextValue = {
    requestCsvDownload: triggerCsvDownload,
  };
  const goBack = () => {
    navigate(-1);
  };

  const PRINT_ROUTE_MAP = [
    {
      print: "/print/orders",
      adminBase: "/admin/orders",
      adminEdit: (id: string) => `/admin/orders?id=${id}`,
    },
    {
      print: "/print/payment",
      adminBase: "/admin/payments",
      adminEdit: (id: string) => `/admin/payments?id=${id}`,
    },
    {
      print: "/print/crnote",
      adminBase: "/admin/credit-notes",
      adminEdit: (id: string) => `/admin/credit-notes?id=${id}`,
    },
    {
      print: "/print/crjnl",
      adminBase: "/admin/credit-journals",
      adminEdit: (id: string) => `/admin/credit-journals?id=${id}`,
    },
    {
      print: "/print/dbjnl",
      adminBase: "/admin/debit-journals",
      adminEdit: (id: string) => `/admin/debit-journals?id=${id}`,
    },
    {
      print: "/print/supplier-order",
      adminBase: "/admin/supplier-order",
      adminEdit: (id: string) => `/admin/supplier-orders?id=${id}`,
    },
    {
      print: "/print/debtor-balance",
      adminBase: "/admin/debtor-balance",
      adminEdit: (id: string) => `/admin/debtor-balance`,
    },
    {
      print: "/print/price-list",
      adminBase: "/admin/price-list",
      adminEdit: (id: string) => `/admin/price-list`,
    },
  ];
  const usePrintRoute = () => {
    const { pathname } = useLocation();

    return PRINT_ROUTE_MAP.find((route) => pathname.startsWith(route.print));
  };
  const route = usePrintRoute();

  // const exportToPDF = async () => {
  //   setExporting(true);
  //   const elementsToHide = document.querySelectorAll(".no-print");
  //   try {
  //     elementsToHide?.forEach((el) => {
  //       (el as HTMLElement).style.display = "none";
  //     });
  //     const element = document.getElementById("preview-content");
  //     if (!element) return;

  //     const canvas = await html2canvas(element);
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const width = pdf.internal.pageSize.getWidth();
  //     const usableWidth = width - PRINT_MARGIN * 2;
  //     const usableHeight = (canvas.height * usableWidth) / canvas.width;

  //     pdf.addImage(
  //       imgData,
  //       "PNG",
  //       PRINT_MARGIN,
  //       PRINT_MARGIN,
  //       usableWidth,
  //       usableHeight,
  //     );
  //     pdf.save(`${filename}-${id}.pdf`);

  //     notifications.show({
  //       title: MSG_DEFAULT_DOWNLOAD_TITLE,
  //       message: "Your order has been saved as a PDF.",
  //       position: MantineNotificationPosition.TopCenter,
  //       color: MantineNotificationColor.Warn,
  //     });
  //   } catch (error) {
  //     notifications.show({
  //       title: MSG_DEFAULT_DOWNLOAD_TITLE,
  //       message: "Something went wrong during PDF export.",
  //       position: MantineNotificationPosition.TopCenter,
  //       color: MantineNotificationColor.Error,
  //     });
  //     console.error(error);
  //   } finally {
  //     setExporting(false);
  //     elementsToHide?.forEach((el) => {
  //       (el as HTMLElement).style.display = "none";
  //     });
  //   }
  // };

  // const exportToPDF = async () => {
  //   setExporting(true);
  //   const elementsToHide = document.querySelectorAll(".no-print");

  //   try {
  //     elementsToHide.forEach((el) => {
  //       (el as HTMLElement).style.display = "none";
  //     });

  //     const element = document.getElementById("preview-content");
  //     if (!element) return;

  //     const canvas = await html2canvas(element, {
  //       scale: 2,
  //       useCORS: true,
  //     });

  //     const pageOrientation =
  //       isGPMRoute ||
  //       (isSupplierOrderRoute && (type === "costing" || type === "prices")) ||
  //       (isPriceListRoute && ReportType === 0)
  //         ? "landscape"
  //         : "portrait";

  //     const pdf = new jsPDF({
  //       orientation: pageOrientation,
  //       unit: "mm",
  //       format: "a4",
  //     });

  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     const imgWidth = pageWidth - PRINT_MARGIN * 2;
  //     const imgHeightMm = pageHeight - PRINT_MARGIN * 2;

  //     // Compute full canvas height in mm
  //     const fullImgHeightMm = (canvas.height * imgWidth) / canvas.width;

  //     // Compute px/mm ratio using canvas height (correct)
  //     const pxPerMm = canvas.height / fullImgHeightMm;

  //     // Compute EXACT pixel height available per PDF page
  //     const pageHeightPx = imgHeightMm * pxPerMm;

  //     // Slice height in px (exact)
  //     const sliceHeightPx = Math.floor(pageHeightPx);

  //     let offsetPx = 0;
  //     let pageIndex = 0;

  //     while (offsetPx < canvas.height) {
  //       const actualSlicePx = Math.min(sliceHeightPx, canvas.height - offsetPx);

  //       const sliceCanvas = document.createElement("canvas");
  //       sliceCanvas.width = canvas.width;
  //       sliceCanvas.height = actualSlicePx;

  //       const sliceCtx = sliceCanvas.getContext("2d");
  //       if (!sliceCtx) break;

  //       sliceCtx.drawImage(
  //         canvas,
  //         0,
  //         offsetPx,
  //         canvas.width,
  //         actualSlicePx,
  //         0,
  //         0,
  //         canvas.width,
  //         actualSlicePx,
  //       );

  //       const imgData = sliceCanvas.toDataURL("image/png");

  //       if (pageIndex > 0) pdf.addPage();

  //       pdf.addImage(
  //         imgData,
  //         "PNG",
  //         PRINT_MARGIN,
  //         PRINT_MARGIN,
  //         imgWidth,
  //         imgHeightMm, // exact mm height
  //       );

  //       offsetPx += actualSlicePx;
  //       pageIndex++;
  //     }

  //     pdf.save(`${filename}-${id}.pdf`);
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setExporting(false);
  //     elementsToHide.forEach((el) => {
  //       (el as HTMLElement).style.display = "block";
  //     });
  //   }
  // };

  const handlePrint = () => {
    window.print();
  };

  return (
    <PrintContext.Provider value={contextValue}>
      <div
        className={`${isGPMRoute || (isSupplierOrderRoute && (type === "costing" || type === "prices")) || (isPriceListRoute && ReportType === 0) ? "print-containerls" : "print-container"}`}
      >
        <div className="print-header">
          <Group justify="space-between" mb="md">
            {route && backToOrderEntry ? (
              <Group justify="flex-start">
                <Button
                  variant="light"
                  color="gray"
                  leftSection={<IconArrowLeft size={16} />}
                  onClick={() => navigateTo(route.adminBase)}
                >
                  Back
                </Button>

                {id && (
                  <Button
                    variant="light"
                    color="gray"
                    leftSection={<IconArrowLeft size={16} />}
                    onClick={() => navigateTo(route.adminEdit(id))}
                  >
                    Back to entry
                  </Button>
                )}
              </Group>
            ) : (
              <Button
                variant="light"
                color="gray"
                leftSection={<IconArrowLeft size={16} />}
                onClick={goBack}
              >
                Back
              </Button>
            )}

            <Group>
              <Button
                leftSection={<IconPrinter size={16} />}
                onClick={handlePrint}
                variant="default"
              >
                Print
              </Button>

              <Button
                leftSection={<IconFileText size={16} />}
                onClick={handlePrint}
                variant="outline"
                color="blue"
              >
                {exporting ? <Loader size="xs" /> : "Export PDF"}
              </Button>

              {isSupplierOrderRoute && (
                <>
                  <Button
                    onClick={triggerCsvDownload}
                    variant="outline"
                    color="blue"
                    leftSection={<IconDownload size={16} />}
                  >
                    Download CSV
                  </Button>
                </>
              )}
            </Group>
          </Group>
        </div>
        <div id="preview-content">
          <Outlet context={{ csvRequestId }} />
        </div>
      </div>
    </PrintContext.Provider>
  );
};

export default MainPrintPage;
